module.exports = __webpack_public_path__ + "static/media/16UNODC36.fe4b7644.jpg";